module.exports = __webpack_public_path__ + "img/kuan_highlight.5214e484.png";